/**
 * @fileoverview App bar title component with home navigation button and a
 * live 24-hour clock visible on medium screens and above.
 */

import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { BiSolidHomeSmile } from 'react-icons/bi';
import { useNavigate } from 'react-router';
import { TooltipIconButton } from '@/shared/components';

function useClock(): { hm: string; ss: string } {
  const format = (d: Date) => {
    const t = d.toLocaleTimeString('en-GB', { hour12: false });
    return { hm: t.slice(0, 5), ss: t.slice(5) };
  };

  const [time, setTime] = React.useState(() => format(new Date()));

  React.useEffect(() => {
    const id = setInterval(() => setTime(format(new Date())), 1_000);
    return () => clearInterval(id);
  }, []);

  return time;
}

export function AppBarTitle(): React.JSX.Element {
  const navigate = useNavigate();
  const { hm, ss } = useClock();

  return (
    <Stack direction="row" spacing={2} sx={{
      alignItems: "center"
    }}>
      <TooltipIconButton
        tooltip="Home"
        type="button"
        aria-label="home"
        onClick={() => navigate('/')}
        sx={{
          color: 'primary.main',
        }}
      >
        <BiSolidHomeSmile size={22} />
      </TooltipIconButton>
      <Box sx={{ pt: 0.25, display: { xs: 'none', sm: 'block' } }}>
      <Typography
        variant="body1"
        sx={{
          fontFamily: '"Inter", sans-serif',
          fontWeight: 400,
          fontSize: '1.4rem',
          color: 'text.primary',
          whiteSpace: 'nowrap',
          letterSpacing: '0.12em',
          userSelect: 'none',
        }}
      >
        {hm}<Typography component="span" sx={{ fontSize: '0.65em' }}>{ss}</Typography>
      </Typography>
      </Box>
    </Stack>
  );
}
